import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "@studio-freight/lenis";
import { motion } from "framer-motion";
import { useAccount } from "wagmi";
import { useLayoutEffect } from "react";
import { authApi } from "services/auth";
import {
  isUserRejectedRequestError,
  useWalletAuthentication,
} from "hooks/useWalletAuthentication";
import "./Landing/style.css";
import { Banner } from "./Landing/components/Banner";
import BurgerMenu from "./Landing/components/BurgerMenu";
import LandingHeader from "./Landing/components/LandingHeader";
import { DarkFooter } from "./Landing/components/DarkFooter";
import { tokensApi } from "services/tokens";
import { useUserStore } from "store/user";
import HeadSetIcon from "assets/svgComponents/PresaleBlock/HeadSetIcon";
import { CustomTooltip } from "./Dashboard/Components/Tooltip";
import { HeroBackdrop } from "./Landing/components/shared";

export function MainLayout() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const { user } = useUserStore();

  const { isConnected, address } = useAccount();

  const isWalletConnected = isConnected && address;

  const location = useLocation();
  const isLandingRoute = location.pathname === "/" || location.pathname === "";

  useEffect(() => {
    const checkAndSaveReferralCode = async () => {
      const hashPath = window.location.hash;

      const match = hashPath.match(/referral\/([^/?#]+)/);
      const referralCode = match?.[1];

      if (!referralCode) return;

      const existingCode = localStorage.getItem("referralCode");
      if (!existingCode && isConnected && user.id) {
        try {
          const isValid = await tokensApi.isRefCodeValid(referralCode);
          if (isValid) {
            localStorage.setItem("referralCode", referralCode);
          } else {
            console.warn("Referral code is invalid");
          }
        } catch (error) {
          console.error("Failed to check referral code:", error);
        }
      }

      if (window.location.hash.includes("referral/")) {
        window.history.replaceState(null, "", "#/");
      }
    };

    checkAndSaveReferralCode();
  }, [location]);

  useLayoutEffect(() => {
    tokensApi.getCurrentRound();
    tokensApi.getCurrentReferralProgram();
    tokensApi.getProgress();
    tokensApi.getCurrentBonus();
    tokensApi.getSettings();
    tokensApi.getBanner();
    authApi.getMyOrders();
  }, [isWalletConnected]);
  const requestSignature = useWalletAuthentication();

  useLayoutEffect(() => {
    if (!address) return;
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      requestSignature().catch((error) => {
        if (!isUserRejectedRequestError(error)) {
          console.warn("Failed to authenticate wallet:", error);
        }
      });
    }

    authApi.refresh(address).catch(() =>
      requestSignature().catch((error) => {
        if (!isUserRejectedRequestError(error)) {
          console.warn("Failed to re-authenticate wallet:", error);
        }
      }),
    );
  }, [address, requestSignature]);

  if (isLandingRoute) {
    return (
      <>
        <main>
          <Outlet />
        </main>
        <CustomTooltip
          content="Open Telegram Support"
          side="left"
          sideOffset={15}
          wrapperClassName="-translate-y-6 z-[10]"
          contentClassName="whitespace-nowrap"
        >
          <a
            className="fixed bottom-8 right-8 z-50 p-4 duration-300 rounded-full hover:scale-110
       bg-white shadow-lg cursor-pointer transition-all"
            href="https://t.me/agnthub_support_bot"
            target="_blank"
          >
            <HeadSetIcon width={20} height={20} />
          </a>
        </CustomTooltip>
      </>
    );
  }

  return (
    <>
      <Banner />
      <BurgerMenu handleClose={handleClose} isOpen={isOpen} />
      <section className="flex flex-col w-full pt-4 lg:pt-8 box-border bg-[#0a0a0a] text-white min-h-dvh relative overflow-x-hidden">
        <HeroBackdrop position="absolute" />

        <motion.div
          className="relative z-10"
          initial={{ opacity: 0, y: -75 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.4,
            duration: 0.5,
            ease: "easeOut",
          }}
        >
          <LandingHeader handleOpen={handleOpen} />
        </motion.div>

        <main className="relative z-10 w-full flex-1">
          <Outlet />
        </main>

        <div className="relative z-10">
          <DarkFooter hideProductColumn />
        </div>
      </section>
      <BurgerMenu handleClose={handleClose} isOpen={isOpen} />
      <CustomTooltip
        content="Open Telegram Support"
        side="left"
        sideOffset={15}
        wrapperClassName="-translate-y-6"
        contentClassName="whitespace-nowrap"
      >
        <a
          className="fixed bottom-8 right-8 z-50 p-4 duration-300 rounded-full hover:scale-110
       bg-white shadow-lg cursor-pointer transition-all"
          href="https://t.me/agnthub_support_bot"
          target="_blank"
        >
          <HeadSetIcon width={20} height={20} />
        </a>
      </CustomTooltip>
    </>
  );
}
